import catalogData from './cloudLocationCatalog.json';

// Display metadata only: never replace region codes sent to the API.
// Verified 2026-11-03 against the providers' geographic location tables:
// https://docs.aws.amazon.com/global-infrastructure/latest/regions/aws-regions.html
// https://docs.aws.amazon.com/local-zones/latest/ug/available-local-zones.html
// https://learn.microsoft.com/en-us/azure/reliability/regions-list
// https://docs.cloud.google.com/compute/docs/regions-zones
const catalog: Record<string, string[]> = catalogData;
export type RegionLocationInput = string | null | undefined | {
  region_code?: string | null; name?: string | null; location?: string | null;
  continent?: string | null; id?: string;
};
const continents: Record<string, string[]> = {
  'North America': ['United States', 'Canada', 'Mexico'],
  'South America': ['Argentina', 'Brazil', 'Chile', 'Peru'],
  Europe: ['Austria', 'Belgium', 'Denmark', 'Finland', 'France', 'Germany', 'Greece', 'Ireland', 'Italy', 'Netherlands', 'Norway', 'Poland', 'Spain', 'Sweden', 'Switzerland', 'United Kingdom'],
  Africa: ['Nigeria', 'South Africa'],
  Oceania: ['Australia', 'New Zealand'],
  Asia: ['Bahrain', 'Hong Kong', 'India', 'Indonesia', 'Israel', 'Japan', 'Malaysia', 'Philippines', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Korea', 'Taiwan', 'Thailand', 'Turkey', 'United Arab Emirates', 'Vietnam'],
};
export function getRegionLocation(input: RegionLocationInput) {
  const row = typeof input === 'object' && input ? input : {};
  const code = (typeof input === 'string' ? input : row.region_code || row.name || row.id || '').trim();
  const key = code.toLowerCase();
  const local = key.match(/^([a-z]{2}(?:-[a-z]+)+-\d+)-[a-z0-9]+-\d+[a-z]$/);
  const parentCode = local?.[1];
  // Standard AWS and GCP availability zones inherit the known region location.
  // Unknown Local Zones do NOT inherit their parent's country (which may differ).
  const base = key.replace(/-?[a-z]$/, '');
  const entry = catalog[key] || (!local ? catalog[base] : undefined);
  const city = entry?.[0] || '';
  const country = entry?.[1] === 'UAE' ? 'United Arab Emirates' : entry?.[1] || '';
  const knownLabel = city === country ? city : [city, country].filter(Boolean).join(', ');
  const location = row.location?.trim();
  const label = location && location !== code ? location : knownLabel || row.name || code || '—';
  const continent = row.continent || Object.entries(continents).find(([, countries]) => countries.includes(country))?.[0] || '';
  return { code, label, city, country, continent, parentCode, isLocalZone: Boolean(local), known: Boolean(entry || location) };
}
export function formatRegionLocation(input: RegionLocationInput): string {
  const { code, label } = getRegionLocation(input);
  return label === code || !code ? label : `${label} (${code})`;
}
export const normalizeLocationSearch = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
export function regionSearchText(input: RegionLocationInput): string {
  const place = getRegionLocation(input);
  const row = typeof input === 'object' && input ? input : {};
  return normalizeLocationSearch([place.code, place.label, place.city, place.country, place.continent,
    row.name, row.location, place.isLocalZone ? 'Local Zone' : '', place.parentCode].filter(Boolean).join(' '));
}
